import App from '../App'
import Manage from '../pages/Manage'
import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import Colum from '../pages/Colum'
import Newflash from '../pages/Newflash'
import Process from '../pages/Process'
import Voice from '../pages/Voice'
import Live from '../pages/Live'
import Wqsd from '../pages/Wqsd'
import Industry from '../pages/Industry'
import Service from '../pages/Service'
import SdkjContent from '../pages/SdkjContent'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      component:App,
      children:[
        {
          path:'',
          redirect: '/home'
        },
        {
          path:'/manage',
          component:Manage,
          children:[
            {
              path:'/home',
              name:'home',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Home
            },
            {
              path:'/colum',
              name:'colum',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Colum
            },
            {
              path:'/newflash',
              name:'newflash',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Newflash
            },
            {
              path:'/process',
              name:'process',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Process
            },
            {
              path:'/voice',
              name:'voice',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Voice
            },
            {
              path:'/live',
              name:'live',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Live
            },
            {
              path:'/wqsd',
              name:'wqsd',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Wqsd
            },
            {
              path:'/industry',
              name:'industry',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Industry
            },
            {
              path:'/service',
              name:'service',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:Service
            },
            {
              path:'/sdkjcontent',
              name:'sdkjcontent',
              meta:{keepAnimation: false , keepAlive:true,top:true,title:"凤舞申城 逐梦湾区| 顺德赴上海推介向全球发出“邀请函”_顺德城市网"},
              component:SdkjContent
            }
          ]
        }
        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js